import sessionStorage from './sessionStorage';

export default {
  get() {
    return sessionStorage.get('userInfo') || {};
  },
  set(info) {
    sessionStorage.set('userInfo', info);
  },
  getRights() {
    return sessionStorage.get('userRights') || {};
  },
  setRights(info) {
    sessionStorage.set('userRights', info);
  },
  clear() {
    sessionStorage.remove('userInfo');
  },
  clearRights() {
    sessionStorage.remove('userRights');
  },
  getPassphrase() {
    let passTime = sessionStorage.get('passTime') === null ? 0 : sessionStorage.get('passTime');
    let nowTime = new Date().getTime();
    let second = nowTime - passTime < 28800000;
    return second ? sessionStorage.get('passphrase') : null;
  },
  setPassphrase(passphrase) {
    let passTime = new Date().getTime();
    sessionStorage.set('passphrase', passphrase);
    sessionStorage.set('passTime',passTime);
  },
};
